import { render } from "./LigthButton.vue?vue&type=template&id=7da89c28&scoped=true"
import script from "./LigthButton.vue?vue&type=script&lang=js"
export * from "./LigthButton.vue?vue&type=script&lang=js"

import "./LigthButton.vue?vue&type=style&index=0&id=7da89c28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7da89c28"]])

export default __exports__